import SvgIcon from '../../Icon/SvgIcon';
import PrimaryButton from '../../Button/PrimaryButton';
import { useAppSelector } from '../../../redux/hooks';
import { workspacePropertySelector } from '../../../redux/selectors/workspace';
import useUser from '../../../utils/hooks/useUser';
import { useState } from 'react';
import WorkspaceToScratchpadModal from '../WorkspaceToScratchpadModal';
import { ScratchpadProvider } from '../../Scratchpad/ScratchpadContext';

const WorkspaceToScratchpad = () => {
  const creator = useAppSelector((state) =>
    workspacePropertySelector(state, 'creator'),
  );
  const workspaceId = useAppSelector((state) =>
    workspacePropertySelector(state, 'id'),
  );

  const wsName = useAppSelector((state) =>
    workspacePropertySelector(state, 'name'),
  );
  const [show, setShow] = useState<boolean>(false);
  const user = useUser();

  const isCreator = creator.id === user.id;

  return (
    <ScratchpadProvider>
      <PrimaryButton
        onClick={() => setShow(true)}
        type="button"
        disabled={!isCreator}
        trackContext="workspaces"
        trackAction="convert to scratchpad - open modal"
      >
        <SvgIcon name="note" width={16} height={16} customFill="currentColor" />
        Convert to Scratchpad
      </PrimaryButton>
      <WorkspaceToScratchpadModal
        workspaceId={workspaceId}
        onClose={() => setShow(false)}
        workspaceName={wsName}
        show={show}
      />
    </ScratchpadProvider>
  );
};

export default WorkspaceToScratchpad;
